/* Règle de victoire d'une quête défi : la valeur enregistrée reste celle
   d'origine (envoyée au serveur, portée par les quêtes existantes) ; seul le
   libellé affiché suit le vocabulaire du back-office. */
export const REGLES_VICTOIRE = [
  "Premier POI valide soumis",
  "Meilleur dossier (qualité photo + données)",
  "Xème collecteur",
] as const;

const LIBELLES: Record<string, string> = {
  "Premier POI valide soumis": "Premier lieu valide soumis",
  "Xème collecteur": "Xème Spotter",
};

/** Libellé affiché pour une valeur enregistrée, y compris « Xème collecteur (100) ». */
export const libelleRegleVictoire = (valeur: string): string => {
  const base = Object.keys(LIBELLES).find((v) => valeur.startsWith(v));
  return base ? LIBELLES[base] + valeur.slice(base.length) : valeur;
};
